/**
 * RbsPortalBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApproverDto { 
    id?: number;
    deleted?: boolean;
    account?: string | null;
    givenName?: string | null;
    surname?: string | null;
    email?: string | null;
    approvalLimit?: number;
}

